import { hasFutureObjects } from 'shared/containers/NewbuildingMapContainer/utils';

import { getIsMapServicesEnabled } from './getIsMapServicesEnabled';
import { getIsTransportAccessibilityServiceAvailable } from './getIsTransportAccessibilityServiceAvailable';
import { getRegularInfrastructure } from './getRegularInfrastructure';
import { IState } from '../../store';

/**
 * Видима ли панель сервисов на карте в правом верхнем углу.
 */
export function getIsMapServicesVisible(state: IState) {
  const mapServicesEnabled = getIsMapServicesEnabled(state);

  if (!mapServicesEnabled) {
    return false;
  }

  const isTransportAccessibilityServiceAvailable = getIsTransportAccessibilityServiceAvailable(state);
  const regularInfrastructure = getRegularInfrastructure(state);

  return isTransportAccessibilityServiceAvailable || hasFutureObjects(regularInfrastructure);
}
